import Leaflet from "leaflet";

export const computeBounds = geometry => {
  if (geometry.type === "Point") {
    const [lng, lat] = geometry.coordinates;
    const offset = 0.00075;
    const c1 = Leaflet.latLng(lat - offset, lng - offset);
    const c2 = Leaflet.latLng(lat + offset, lng + offset);
    return Leaflet.latLngBounds(c1, c2);
  }
  return Leaflet.GeoJSON.geometryToLayer(geometry).getBounds();
};



// WEBPACK FOOTER //
// ./src/app/map/utils.js